<div class="status-table-wrapper">

    <!-- Cutoff Label -->
    <div *ngIf="cutoffLabel" class="cutoff-label">{{ cutoffLabel }}</div>

    <!-- Status Table -->
    <table class="status-table">
        <thead>
            <tr>
                <th *ngFor="let col of columns">{{ col.header }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let row of rows; let i = index" [class.row-alt]="i % 2 === 0">
                <td class="downtime-cell">{{ row.downtime }}</td>
                <td class="status-cell">
                    <span class="status-label">{{ row.status }}</span>
                    <span class="status-dot" [style.background-color]="row.statusColor"></span>
                </td>
            </tr>
        </tbody>
    </table>

</div>